<template>
  <div class="GlassMapping">
    <ATable
      ref="table"
      :data="items"
      :placeholder="placeholder"
      :search_field="search_field"
      :disable_insert="!has_grant_write"
      border
      hide-pagination
      @cell-click="handleCellClick"
      @clicked-create="handleClickedCreate"
    >
      <el-table-column
        type="index"
        label="No"
        align="center"
        prop="index"
        :width="$width.index"
        :index="handleIndex"
      />
      <el-table-column prop="product_id" label="품목" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <ASelector v-model="scope.row.product_id" :items="glass_products" />
          </div>
          <div v-else>
            {{ scope.row.product_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="glass_color_id" label="색상" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <ASelector
              v-model="scope.row.glass_color_id"
              v-bind:class="{ 'readonly-noborder': scope.row.id !== editingId }"
              :items="table_glass_color"
              :readonly="scope.row.id !== editingId"
            />
          </div>
          <div v-else>
            {{ scope.row.glass_color_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="glass_thickness_ids" label="두께">
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <ASelector
              v-model="scope.row.glass_thickness_ids"
              class="w-full"
              :items="table_glass_thickness"
              multiple
            />
          </div>
          <div v-else>
            {{ scope.row.glass_thickness_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="명령" width="150">
        <template slot-scope="scope">
          <div v-show="scope.row.id === editingId">
            <el-button
              type="primary"
              size="mini"
              :disabled="!has_grant_write"
              :loading="load_button"
              @click="handleClickRegister(scope.row)"
              >저장</el-button
            >
            <el-button size="mini" @click="calcelEditing(scope.row)"
              >취소</el-button
            >
          </div>
          <div v-show="scope.row.id !== editingId">
            <el-button
              type="danger"
              size="mini"
              :disabled="!has_grant_write"
              :loading="load_button"
              @click="handleClickDelete(scope.row)"
              >삭제</el-button
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_user_name"
        :label="$t('lang.created_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="modified_user_name"
        :label="$t('lang.modified_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="created_at"
        :label="$t('lang.created_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
      <el-table-column
        prop="modified_at"
        :label="$t('lang.modified_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
    </ATable>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { base_data } from "@/common/mixins/base_data";

export default {
  name: "GlassMapping",
  mixins: [base_data],
  data() {
    return {
      title: this.$t("title.glass_mapping"),
      placeholder: "품목, 색상, 두께",
      search_field: [
        "product_name",
        "glass_color_name",
        "glass_thickness_name",
      ],
      items: [],
      editingId: -1,
      oldItem: undefined,
      deleteData: undefined,
      base_data: ["table_product_glass_price"],
      load_button: false,
    };
  },
  props: {
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      "table_product",
      "table_glass_color",
      "table_glass_thickness",
      "table_product_glass_price",
    ]),
    glass_products: function() {
      return this.table_product.filter((p) => p.kind === "GLASS");
    },
  },
  mounted() {
    this.init();
  },
  destroyed() {
    if (this.editingId < 0) {
      return;
    }
    this.calcelEditing(this.oldItem);
    this.editingId = -1;
  },
  methods: {
    init() {
      this.items = this.initItems();
    },
    initItems() {
      let items = [];
      this.table_product_glass_price.forEach((e) => {
        let item = items.find(
          (item) =>
            item.product_id === e.product_id &&
            item.glass_color_id === e.glass_color_id
        );
        // let thickness = this.table_glass_thickness.find(c => c.id === e.glass_thickness_id);
        if (item) {
          item.glass_thickness_ids.push(e.glass_thickness_id);
          // item.glass_thickness_name += ' ' + thickness.name;
          if (e.modified_at > item.modified_at) {
            item.modified_user_name = e.modified_user_name;
            item.modified_at = e.modified_at;
          }
        } else {
          let product = this.table_product.find((p) => p.id === e.product_id);
          let color = this.table_glass_color.find(
            (c) => c.id === e.glass_color_id
          );
          item = {
            id: e.id,
            product_id: e.product_id,
            product_name: product.name,
            glass_color_id: e.glass_color_id,
            glass_color_name: color?.name,
            glass_thickness_ids: [e.glass_thickness_id],
            // glass_thickness_name: thickness.name
            created_user_name: e.created_user_name,
            modified_user_name: e.modified_user_name,
            created_at: e.created_at,
            modified_at: e.modified_at,
          };
          items.push(item);
        }
      });
      //두께를 숫자별로 정렬
      items.forEach((item) => {
        item.glass_thickness_ids.sort(this.sortGlassThickness);
        item.glass_thickness_name = "";
        item.glass_thickness_ids.forEach((id) => {
          let thickness = this.table_glass_thickness.find((t) => t.id === id);
          if (!thickness) item.glass_thickness_name += "두께를 선택해주세요.";
          if (items.glass_thickness_name !== " ") {
            item.glass_thickness_name += " " + thickness?.name;
          } else {
            item.glass_thickness_name += thickness?.name;
          }
        });
      });
      return items;
    },
    calcelEditing(data) {
      let index = this.items.findIndex((i) => i.id === data.id);
      if (this.oldItem.id) {
        this.items.splice(index, 1, this.oldItem);
      } else {
        this.items.splice(index, 1);
      }
      this.editingId = -1;
    },
    doDelete() {
      this.load_button = true;
      this.api.deleteProductGlass(this.deleteData).then((res) => {
        this.load_button = false;
        this.handleResult(res, this.$t("message.success_delete"));
      });
    },
    sortGlassThickness(a, b) {
      let ta = this.table_glass_thickness.find((t) => t.id === a);
      let tb = this.table_glass_thickness.find((t) => t.id === b);
      ta = Number.parseFloat(ta.name);
      tb = Number.parseFloat(tb.name);
      if (ta > tb) {
        return 1;
      } else if (ta < tb) {
        return -1;
      } else {
        return 0;
      }
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleClickedCreate() {
      if (this.editingId > -1) {
        this.calcelEditing(this.oldItem);
      }
      this.editingId = 0;
      this.oldItem = {
        id: 0,
        product_id: null,
        glass_color_id: null,
        glass_thickness_ids: [],
      };
      this.items.push(this.oldItem);
    },
    handleCellClick(item, column) {
      if (this.editingId === item.id) {
        return;
      }
      if (this.editingId > -1) {
        this.calcelEditing(this.oldItem);
      }
      if (!column.property) {
        return;
      }
      this.editingId = item.id;
      this.oldItem = Object.assign({}, item);
    },
    handleClickRegister(data) {
      if (!data.product_id) {
        this.util.notify_warning(this, this.title, "품목을 선택해주세요.");
        return;
      }
      if (!data.glass_color_id) {
        this.util.notify_warning(this, this.title, "색상을 선택해주세요.");
        return;
      }
      if (data.glass_thickness_ids.length < 1) {
        this.util.notify_warning(this, this.title, "두께를 선택해주세요.");
        return;
      }
      let duplicated = this.items.find((item) => {
        return (
          item.id !== data.id &&
          item.product_id === data.product_id &&
          item.glass_color_id === data.glass_color_id
        );
      });
      if (duplicated) {
        this.util.notify_warning(this, this.title, "중복된 품목과 색상입니다.");
        return;
      }
      this.load_button = true;
      this.api.registerProductGlass(data).then((res) => {
        this.load_button = false;
        this.handleResult(res, this.$t("message.success_register"));
      });
    },
    handleClickDelete(data) {
      this.deleteData = data;
      this.util.confirm_delete(
        this,
        this.title + "[" + data.name + "]",
        this.doDelete
      );
    },
    handleResult(res, successMessage) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.editingId = -1;
      this.util.notify_success(this, this.title, successMessage);
    },
  },
};
</script>
